module.exports = __webpack_public_path__ + "img/TDE_120X35.5e331de8.png";